import { render, staticRenderFns } from "./overviewCapital.vue?vue&type=template&id=68681cf0&scoped=true&"
import script from "./overviewCapital.vue?vue&type=script&lang=js&"
export * from "./overviewCapital.vue?vue&type=script&lang=js&"
import style0 from "./overviewCapital.vue?vue&type=style&index=0&id=68681cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68681cf0",
  null
  
)

export default component.exports